import React from "react";
import { Drawer } from "antd";
import { IDrawerProps } from "./interface";
import ZTypography from "@atoms/ZTypography";
import { EFontWeights } from "@atoms/ZTypography/interface";
import "./index.less";
import useMobileView from "@/Hooks/useMobileView";

const ZDrawer: React.FC<IDrawerProps> = ({
	visible = false,
	title = "",
	removeDefaultPadding = false,
	className = "",
	shouldTitleTruncate = true,
	...rest
}) => {
	const isMobileView = useMobileView();

	return (
		<Drawer
			className={`z-drawer ${className} ${
				isMobileView ? "mobile-view" : ""
			}`}
			visible={visible}
			closable={true}
			destroyOnClose={true}
			footer={rest.footer}
			bodyStyle={
				removeDefaultPadding
					? { padding: "0px" }
					: { padding: "24px 24px" }
			}
			onClose={rest.onClose}
			title={
				typeof title === "string" ? (
					<ZTypography.ZText
						level={2}
						weight={EFontWeights.MEDIUM}
						className={`'flex' 'items-center' 'leading-6' 'max-w-full' ${
							shouldTitleTruncate ? "truncate" : ""
						}`}
					>
						{title}
					</ZTypography.ZText>
				) : (
					title
				)
			}
			maskClosable={rest.maskClosable ?? false}
			{...rest}
		>
			{rest.children}
		</Drawer>
	);
};

export default ZDrawer;
